export const validaUploadEmprestimos = ({
  e,
  setModalIsOpen,
  form,
  campo,
  setArquivosEnvio,
  arquivosEnvio,
  isPendencia = false,
}) => {
  const convertFileListIntoArray = [...arquivosEnvio, ...e.currentTarget.files];
  const filteredFilesByType = convertFileListIntoArray.filter(
    (file) => file.type.includes('image/') || file.type.includes('pdf')
  );

  const dataTransfer = new DataTransfer();

  filteredFilesByType.forEach((file) => dataTransfer.items.add(file));

  if (e && e.currentTarget && e.currentTarget.files) {
    // eslint-disable-next-line no-param-reassign
    e.currentTarget.files = dataTransfer.files;
    // eslint-disable-next-line no-param-reassign
    e.target.files = dataTransfer.files;
  }

  if (convertFileListIntoArray.length !== filteredFilesByType.length) {
    if (!isPendencia) {
      setModalIsOpen(true);
    } else {
      setModalIsOpen();
    }
  } else if (dataTransfer.files !== undefined) {
    setArquivosEnvio(convertFileListIntoArray);
  }

  return form.setFieldValue(
    campo,
    filteredFilesByType.length ? dataTransfer.files : null
  );
};
